import { Component, inject, OnInit } from '@angular/core';
import { JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgbActiveModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

import { CommonService } from '../../../utilities/services/common.service';
import { ChatInteractionComponent } from '../chat-interaction/chat-interaction.component';
import { CodeEditorComponent } from '../../../utilities/components/code-editor/code-editor.component';

@Component({
    selector: 'chat-debug-modal',
    imports: [NgbNavModule, ChatInteractionComponent, JsonPipe, CodeEditorComponent, FormsModule],
    templateUrl: './chat-debug-modal.component.html',
    styleUrls: ['./chat-debug-modal.component.scss']
  })
export class ChatDebugModalComponent implements OnInit {
  public readonly activeModal = inject(NgbActiveModal);
  public readonly commonService = inject(CommonService);

  public dialog!: any[];
  public selectedInteraction: any;
  public botDialog!: any[];
  public interactionIndex!: number;
  public elemResized = false;

  ngOnInit(): void {
    this.botDialog = this.dialog.filter((d) => d.type === 'bot');
    this.interactionIndex = this.botDialog.findIndex((d) => d === this.selectedInteraction);
  }

  prevInteraction() {
    if (this.interactionIndex === 0) return;
    this.selectedInteraction = this.botDialog[--this.interactionIndex];
  }

  nextInteraction() {
    if (this.interactionIndex === this.botDialog.length - 1) return;
    this.selectedInteraction = this.botDialog[++this.interactionIndex];
  }
}
